import { tailwindMergeConfig } from "shared-web/lib/classNames"
import { extendTailwindMerge, ClassNameValue } from "tailwind-merge"

const baseTheme = tailwindMergeConfig.extend.theme
const baseGroups = tailwindMergeConfig.extend.classGroups

/* DO NOT EDIT THIS FILE */
/**
 * Note: These are all deprecated styles - we should migrate all of them to styles from base.css.
 * Once we do that, we can remove this file.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: baseTheme.text,
      color: [
        ...baseTheme.color,
        "text-primary-light",
        "text-primary-dark",
        "text-placeholder-light",
        "text-placeholder-dark",
        "surface-primary-light",
        "surface-primary-dark",
        "surface-secondary-accent-light",
        "surface-secondary-accent-dark",
        "border-primary-light",
        "border-primary-dark",
        "border-accent-light",
        "border-accent-dark",
        "accent-error-light",
        "accent-error-dark",
      ],
      shadow: baseTheme.shadow,
      animate: baseTheme.animate,
      spacing: baseTheme.spacing,
      radius: baseTheme.radius,
    },
    classGroups: {
      "text-color": [
        ...baseGroups["text-color"],
        "text-primary",
        "text-primary-inverted",
        "text-placeholder",
      ],
      "bg-color": [
        ...baseGroups["bg-color"],
        "surface-primary-inverted",
        "surface-secondary-accent",
      ],
      "border-color": [...baseGroups["border-color"]],
      "divide-color": baseGroups["divide-color"],
      stroke: baseGroups.stroke,
    },
  },
})

export function classNames(...classes: ClassNameValue[]): string {
  return twMerge(classes)
}
